export enum AssignmentStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export enum TrainingRecordMode {
  EDIT_EXISTING_TR = "editExistingTR",
  ADD_NEW_TR = "addNewTR",
}

export interface UpdateAssignment {
  portalAssignmentUid: string;
  users: string[];
}

export interface CreateUserAssignmentsParams {
  users: string[];
  assignments: string[];
  portalGroupUid?: string;
  dueDate?: Date;
  plusDays?: number;
  emptyDueDate?: boolean | null;
  initialNotification?: boolean;
}

export interface EditUserAssignmentsParams {
  assignments: UpdateAssignment[];
  portalGroupUid?: string;
  dueDate?: Date;
  plusDays?: number;
  emptyDueDate?: boolean | null;
  mode?: TrainingRecordMode;
}

export interface RemoveUserAssignmentsParams {
  assignments: UpdateAssignment[];
  adminUser: string;
}

export interface AdminUpdateUserAssignmentBodyParams {
  assignments: UpdateAssignment[];
  status?: AssignmentStatus;
}

export interface AdminGetUserAssignmentsPaginatedResult {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: AdminGetUserAssignmentsResult[];
}

export interface AdminGetUserAssignmentsResult {
  title: string;
  usersCount: number;
  users: UserType[];
  portalGroups: PortalGroupType[];
  dueDatesCount: number;
  dueDates: DueDateType[];
  creationType: string;
  code?: string;
  SKU?: string;
  versionsCount?: number;
  versions?: VersionType[];
  assignmentStatus?: AssignmentStatus;
}

export interface UserType {
  UserPortalUid: string;
  name: string;
  email: string;
}

export interface PortalGroupType {
  id: string;
  name: string;
}

export interface DueDateType {
  dueDate: string;
  count: number;
}

export interface VersionType {
  version: string;
}
